import React from "react"
import { useTranslation } from "react-i18next"
import Skeleton from "react-loading-skeleton"
import "react-loading-skeleton/dist/skeleton.css"

type OptionProps = React.HTMLProps<HTMLOptionElement>

interface SelectProps extends React.HTMLProps<HTMLSelectElement> {
  label: string
  extensionBold: string
  options: OptionProps[]
  loading?: boolean
  showDisabledAsText?: boolean
}

export const Select = (props: SelectProps) => {
  const { t } = useTranslation("common")

  // To show the selected option label as just text instead of a select if disabled
  let overrideText
  if (props.showDisabledAsText && props.disabled) {
    const option = props.options.find((o) => o.value === props.value)
    if (option) {
      overrideText = option.label
    }
  }

  return (
    <div>
      <div className="input-group">
        <label htmlFor={props.label}>
          <span>
            <b style={{ fontWeight: "bold" }}>{props.extensionBold}</b> {props.label}
          </span>
          {props.required && <span className="error-message"> *</span>}
        </label>
        <div className="input-focus-group">
          {overrideText ? (
            <span id={props.label}>{overrideText}</span>
          ) : props.loading ? (
            <Skeleton style={{ height: "2rem" }} />
          ) : (
            <select
              id={props.label}
              name={props.name || props.label}
              placeholder={props.placeholder || props.label}
              value={props.value || ""}
              onChange={props.onChange || undefined}
              autoComplete="off"
              disabled={props.disabled || false}
              required={props.required || false}
            >
              <option disabled={true} value="">
                -- {t("optionPrompt")} --
              </option>
              {props.options.map((option: OptionProps, i: number) => (
                <option key={`select-input-${i}`} {...option}>
                  {option.label}
                </option>
              ))}
            </select>
          )}
          <div className="line" />
        </div>
      </div>
    </div>
  )
}
